import React, { Component } from "react";
import "./DashBoards.css";
import {
  Container,
  Row,
  Col,
  Card,
  Dropdown,
  Modal,
  Form,
  Button,
} from "react-bootstrap";
import { Link, Outlet } from "react-router-dom";
import configData from "../config.json";
import { toast } from "react-toastify";
// import { Responsive, WidthProvider } from "react-grid-layout";
import "react-grid-layout/css/styles.css";
import "react-resizable/css/styles.css";
import * as Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import funnelModule from "highcharts/modules/funnel";
import exportingModule from "highcharts/modules/exporting";
import offlineExporting from "highcharts/modules/offline-exporting";
import LoadingOverlay from "./LoadingOverlay";
if (typeof funnelModule === "function") {
  funnelModule(Highcharts);
} else if (typeof funnelModule.default === "function") {
  funnelModule.default(Highcharts);
}
if (typeof exportingModule === "function") {
  exportingModule(Highcharts);
} else if (typeof exportingModule.default === "function") {
  exportingModule.default(Highcharts);
}

if (typeof offlineExporting === "function") {
  offlineExporting(Highcharts);
} else if (typeof offlineExporting.default === "function") {
  offlineExporting.default(Highcharts);
}
export default class DashBoard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      loadingMessage: "Processing your request...",
      show: false,
      step: 1,
      time: new Date(),
      sId: sessionStorage.getItem("sessionId"),
      uId: sessionStorage.getItem("uId"),
      loginTimes: [],
      logoutTimes: [],
      isWorking: false,
      lastActivity: null,
      data: [],
      data1: [],
      data2: [],
      chartData: {},
      // widgetId: 95,
      showModal: false,
      widgets: [],
      editIndex: null,
      layouttwo: [],
      layout: [],
      drilldownLevel: 0,
      currentChartData: null,
      drillStackByWidget: {},
      drillParamsByWidget: {},
      dealuser: [],
      chartRefs: {},
      employees: [],
    };
    // this.handleUserActivity = this.handleUserActivity.bind(this);
  }

  handleCloseOne = () => {
    this.setState({ showOne: false });
  };
  handleShow = () => {
    this.setState({ show: true });
  };

  handleShowOne = () => {
    this.setState({ showOne: true });
  };
  showToast = (msg, type) => {
    switch (type) {
      case "success":
        toast.success(msg);
        break;
      case "error":
        toast.error(msg);
        break;
      case "warning":
        toast.warn(msg);
        break;
      default:
        toast.info(msg);
    }
  };
  handleShowModal = () => {
    this.setState({ showModal: true });
  };

  handleCloseModal = () => {
    this.setState({ showModal: false, heading: "", content: "" });
  };

  handleChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };
  handleNextStep = () =>
    this.setState((prevState) => ({ step: prevState.step + 1 }));
  handlePrevStep = () => {
    this.setState((prevState) => ({
      step: Math.max(prevState.step - 1, 1), // Limit to min step 1
    }));
  };
  componentDidMount() {
    this.WidgetdefinationfetchHandler();
    this.employeesfetchHandler();
  }

  componentWillUnmount() {
    // Clear all timers and intervals
    if (this.timerID) {
      clearInterval(this.timerID);
    }

    // Clear any pending timeouts
    if (this.fetchTimeoutId) {
      clearTimeout(this.fetchTimeoutId);
    }

    // End current session if method exists
    if (this.endCurrentSession) {
      this.endCurrentSession();
    }

    // Clean up any event listeners if they exist
    // Note: Add specific cleanup based on what event listeners are set up
  }
  // Store chart reference
  setChartRef = (widgetId, chartRef) => {
    this.setState((prevState) => ({
      chartRefs: {
        ...prevState.chartRefs,
        [widgetId]: chartRef,
      },
    }));
  };
  employeesfetchHandler = () => {
    fetch(configData.api_url + "C_Employees/list", {
      // Enter your IP address here
      method: "POST",
      mode: "cors",
      body: {}, // body data type must match "Content-Type" header
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success") {
          this.setState({ employees: data.list });
        }
      });
  };
  WidgetdefinationfetchHandler = () => {
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    fetch(configData.api_url + "C_Widgetdefinition/list", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
      })
      .then((data) => {
        if (data.status === "success") {
          // this.setState({ data: data.list });
          const allWidgets = data.list;
          this.setState({ data: allWidgets });
          const rootWidgets = allWidgets.filter((w) => {
            const widgetId = w.widgetId;
            const destinationId = w.destinationreportId;
            const isNotReferenced = !allWidgets.some(
              (other) =>
                other.destinationreportId === widgetId &&
                other.widgetId !== widgetId // ignore self-referencing
            );
            const isTopLevel =
              !destinationId ||
              destinationId === "0" ||
              w.sourcereportId === "0";
            const isSelfReferencing = widgetId === destinationId;
            return isNotReferenced || isTopLevel || isSelfReferencing;
          });
          allWidgets.forEach((element) => {
            var chartData1 = {
              labels: [],
              datasets: [
                {
                  label: "Loading..",
                  data: [],
                  backgroundColor: [
                    "#FF6384",
                    "#36A2EB",
                    "#FFCE56",
                    "#4BC0C0",
                    "#9966FF",
                  ],
                  borderColor: "rgba(75, 192, 192, 1)",
                  borderWidth: 1,
                },
              ],
            };
            //var chartData1 = this.genreateChartData(data.widgetData.Counts);
            var chartData = this.state.chartData;
            chartData[`card_${element.widgetId}`] = chartData1;
            this.setState({ chartData: chartData });
            this.getwidgetDataFetchHandler(
              element.widgetId,
              `card_${element.widgetId}`,
              element.widgetName,
              element.destinationreportId,
              element.sourcereportId
            );
          });
          //const generatedLayout = data.list.map((item, index) => ({
          const generatedLayout = rootWidgets.map((item, index) => ({
            i: `card_${item.widgetId}`,
            x: (index % 4) * 3,
            y: Math.floor(index / 2) * 2,
            w: Math.max(2, Math.ceil((parseInt(item.minWidth) || 200) / 100)),
            h: Math.max(
              2.5,
              Math.ceil((parseInt(item.minHeight) || 200) / 100)
            ),
            minW: Math.ceil((parseInt(item.minWidth) || 200) / 100),
            minH: Math.ceil((parseInt(item.minHeight) || 200) / 100),
            widgetDetails: item,
            widgetData: this.state.chartData[`card_${item.widgetId}`],
          }));
          this.setState({
            // data: data.list,
            layout: generatedLayout,
          });
        } else {
          this.showToast(data.message || "Failed to load widgets", "error");
        }
      })
      .catch((error) => {
        console.error("Error fetching widget definitions:", error);
        this.showToast(
          "Failed to load dashboard widgets. Please refresh the page.",
          "error"
        );
      });
  };
  getwidgetDataFetchHandler = (
    widgetId,
    name,
    widgetName,
    destinationreportId,
    sourcereportId
  ) => {
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append("fromDate", this.state.fromDate);
    formData.append("toDate", this.state.toDate);
    formData.append("widgetId", widgetId);
    formData.append("destinationreportId", destinationreportId);
    fetch(configData.api_url + "C_Widgetdefinition/getWidgetDataDrilldown1", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
      })
      .then((data) => {
        if (data.status === "success") {
          var chartData1 = this.genreateChartData(
            data.chart_data,
            widgetName,
            widgetId,
            destinationreportId,
            sourcereportId
          );
          chartData1.chart_data = data.chart_data;
          var chartData = this.state.chartData;
          chartData[name] = chartData1;
          this.setState({ chartData: chartData });
        } else {
          console.error("Failed to load widget data:", data.message);
        }
      })
      .catch((error) => {
        console.error("Error fetching widget data:", error);
        // Don't show toast for individual widget failures to avoid spam
      });
  };
  // Update genreateChartData to store member IDs in the chart data
  genreateChartData = (
    widgetCounts,
    widgetName,
    widgetId,
    destinationreportId,
    sourcereportId
  ) => {
    const labels = widgetCounts.map((item) => item.name || "N/A");
    const counts = widgetCounts.map((item) => parseInt(item.y) || 0);

    // Store the full data including IDs
    const chartPoints = widgetCounts.map((item) => ({
      name: item.name,
      y: parseInt(item.y) || 0,
      id: item.id, // Store member ID here
    }));

    const drilldownSeries = widgetCounts.map((item) => ({
      id: item.name,
      name: `${item.name} Details`,
      data: [[item.name, parseInt(item.y) || 0]],
    }));

    const totalCount = counts.reduce((a, b) => a + b, 0);
    return {
      widgetId,
      destinationreportId,
      sourcereportId,
      labels: labels,
      chartPoints: chartPoints, // Add this for reference
      datasets: [
        {
          label: widgetName,
          data: counts,
          backgroundColor: [
            "#FF6384",
            "#36A2EB",
            "#FFCE56",
            "#4BC0C0",
            "#9966FF",
          ],
          borderColor: "rgba(75, 192, 192, 1)",
          borderWidth: 1,
        },
      ],
      drilldown: {
        series: drilldownSeries,
      },
      totalCount,
    };
  };

  drillDownevent = (e, widgetId, destinationreportId, sourcereportId) => {
    const { chartData, drillStackByWidget, drillParamsByWidget, data } =
      this.state;

    const currentWidgetStack = drillStackByWidget[widgetId] || [];
    const currentParamsStack = drillParamsByWidget[widgetId] || [];

    const updatedWidgetStack = [
      ...currentWidgetStack,
      chartData[`card_${widgetId}`],
    ];

    // Find the member ID from the chart_data using the clicked point name
    const currentChartData = chartData[`card_${widgetId}`];
    let memberId = e.point.name;

    // Extract ID from chart_data object
    if (currentChartData?.chart_data) {
      const chartDataObj = currentChartData.chart_data;
      // Loop through object keys to find matching name
      for (let key in chartDataObj) {
        if (chartDataObj[key]?.name === e.point.name && chartDataObj[key]?.id) {
          memberId = chartDataObj[key].id;
          break;
        }
      }
    }

    const updatedParamsStack = [
      ...currentParamsStack,
      {
        name: e.point.name,
        y: e.point.y,
        destinationreportId: destinationreportId,
        sourcereportId: sourcereportId,
      },
    ];

    let nextWidgetDefinition = null;
    if (data && Array.isArray(data)) {
      // Convert both to string for comparison to handle type mismatches
      nextWidgetDefinition = data.find(
        (widget) => String(widget.widgetId) === String(destinationreportId)
      );
    }

    // Get the next destination from the found widget definition
    const nextDestinationId = nextWidgetDefinition
      ? nextWidgetDefinition.destinationreportId
      : null;

    console.log("Drilldown - Current destinationreportId:", destinationreportId,
                "Next destinationId:", nextDestinationId,
                "Found widget:", nextWidgetDefinition?.widgetName);

    // Check if this is the first drilldown (no stack yet) or subsequent
    const isFirstDrilldown = currentWidgetStack.length === 0;

    // Determine isDrillDown: "no" for first click, then based on nextDestinationId
    const isDrillDownValue = isFirstDrilldown
      ? "no"
      : nextDestinationId
      ? "yes"
      : "no";

    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append("widgetId", destinationreportId);
    formData.append("label", memberId); // Send actual member ID
    formData.append("selectedUser", memberId); // Send actual member ID
    formData.append("isDrillDown", isDrillDownValue);

    fetch(configData.api_url + "C_Widgetdefinition/getWidgetDataDrilldown1", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
      })
      .then((data) => {
        if (data.status === "success") {
          // Convert chart_data object to array and filter valid entries
          const chartDataArray = Object.values(data.chart_data).filter(
            (item) =>
              typeof item === "object" &&
              item !== null &&
              "name" in item &&
              "y" in item
          );

          const updatedChartData = {
            ...chartData,
            [`card_${widgetId}`]: {
              ...chartData[`card_${widgetId}`],
              labels: chartDataArray.map((item) => item.name),
              chart_data: data.chart_data, // Keep original data with IDs
              datasets: [
                {
                  label: `${e.point.name} Details`,
                  data: chartDataArray.map((item) => item.y),
                  backgroundColor: this.generateColors(chartDataArray.length),
                  borderColor: "rgba(75, 192, 192, 1)",
                  borderWidth: 1,
                },
              ],
              drilldown: {
                series: data.drilldown_data || [],
              },
              destinationreportId: nextDestinationId,
              widgetId: widgetId,
              sourcereportId: destinationreportId,
              totalCount: chartDataArray.reduce((sum, item) => sum + item.y, 0),
            },
          };

          console.log("=== DRILLDOWN STATE UPDATE ===");
          console.log("Updating card_" + widgetId);
          console.log("NEW destinationreportId:", nextDestinationId);
          console.log("NEW sourcereportId:", destinationreportId);
          console.log("Stack depth after update:", updatedWidgetStack.length);

          this.setState({
            chartData: updatedChartData,
            drillStackByWidget: {
              ...drillStackByWidget,
              [widgetId]: updatedWidgetStack,
            },
            drillParamsByWidget: {
              ...drillParamsByWidget,
              [widgetId]: updatedParamsStack,
            },
          });
        }
      })
      .catch((error) => {
        console.error("Drilldown fetch failed:", error);
      });
  };

  // drillDownevent = (e, widgetId, destinationreportId, sourcereportId) => {
  //   const { chartData, drillStackByWidget, drillParamsByWidget, data } =
  //     this.state;
  //   // if (!destinationreportId || destinationreportId === "0") {
  //   //   console.log("No destination report ID available. End of drill chain.");
  //   //   return;
  //   // }
  //   const currentWidgetStack = drillStackByWidget[widgetId] || [];
  //   const currentParamsStack = drillParamsByWidget[widgetId] || [];
  //   const updatedWidgetStack = [
  //     ...currentWidgetStack,
  //     chartData[`card_${widgetId}`],
  //   ];
  //   const updatedParamsStack = [
  //     ...currentParamsStack,
  //     {
  //       name: e.point.name,
  //       y: e.point.y,
  //       destinationreportId: destinationreportId,
  //       sourcereportId: sourcereportId,
  //     },
  //   ];
  //   let nextWidgetDefinition = null;
  //   if (data && Array.isArray(data)) {
  //     nextWidgetDefinition = data.find(
  //       (widget) => widget.widgetId === destinationreportId
  //     );
  //   }
  //   const nextDestinationId = nextWidgetDefinition
  //     ? nextWidgetDefinition.destinationreportId
  //     : null;
  //   var formData = new FormData();
  //   formData.append("sId", this.state.sId);
  //   formData.append("uId", this.state.uId);
  //   formData.append("widgetId", destinationreportId);
  //   //formData.append("destinationreportId", destinationreportId);
  //   //formData.append("sourcereportId", widgetId);
  //   formData.append("label", e.point.name);
  //   // formData.append("selectedLabel", e.point.name);
  //   // formData.append("selectedValue", e.point.y);

  //   fetch(configData.api_url + "C_Widgetdefinition/getWidgetDataDrilldown1", {
  //     method: "POST",
  //     mode: "cors",
  //     body: formData,
  //   })
  //     .then((response) => response.json())
  //     .then((data) => {
  //       if (data.status === "success") {
  //         const updatedChartData = {
  //           ...chartData,
  //           [`card_${widgetId}`]: {
  //             ...chartData[`card_${widgetId}`],
  //             labels: data.chart_data.map((item) => item.name),
  //             datasets: [
  //               {
  //                 label: `${e.point.name} Details`,
  //                 data: data.chart_data.map((item) => item.y),
  //                 backgroundColor: this.generateColors(data.chart_data.length),
  //                 borderColor: "rgba(75, 192, 192, 1)",
  //                 borderWidth: 1,
  //               },
  //             ],
  //             drilldown: {
  //               series: data.drilldown_data || [],
  //             },
  //             destinationreportId: nextDestinationId,
  //             widgetId: widgetId,
  //             sourcereportId: destinationreportId,
  //             totalCount: data.chart_data.reduce(
  //               (sum, item) => sum + item.y,
  //               0
  //             ),
  //           },
  //         };

  //         this.setState({
  //           chartData: updatedChartData,
  //           drillStackByWidget: {
  //             ...drillStackByWidget,
  //             [widgetId]: updatedWidgetStack,
  //           },
  //           drillParamsByWidget: {
  //             ...drillParamsByWidget,
  //             [widgetId]: updatedParamsStack,
  //           },
  //         });
  //       }
  //     });
  // };
  handleDrillUp = (widgetId) => {
    const { drillStackByWidget, drillParamsByWidget, chartData } = this.state;
    const widgetDrillStack = drillStackByWidget[widgetId] || [];
    const widgetParamsStack = drillParamsByWidget[widgetId] || [];
    if (widgetDrillStack.length === 0) return;
    const previousChartData = widgetDrillStack[widgetDrillStack.length - 1];
    const updatedStack = widgetDrillStack.slice(0, -1);
    const updatedParams = widgetParamsStack.slice(0, -1);
    const updatedChartData = {
      ...chartData,
      [`card_${widgetId}`]: previousChartData,
    };
    this.setState({
      chartData: updatedChartData,
      drillStackByWidget: {
        ...drillStackByWidget,
        [widgetId]: updatedStack,
      },
      drillParamsByWidget: {
        ...drillParamsByWidget,
        [widgetId]: updatedParams,
      },
    });
  };
  prepareStackedOrGroupedData = (chartData) => {
    // If there's no data or invalid data, return empty structure
    if (!chartData || !Array.isArray(chartData) || chartData.length === 0) {
      return {
        categories: [],
        series: [],
      };
    }

    // Get unique state/category names
    const uniqueCategories = Array.from(
      new Set(chartData.map((item) => item.name))
    );

    // Count occurrences of each name to determine how many series we need
    const maxOccurrences = {};
    uniqueCategories.forEach((category) => {
      maxOccurrences[category] = chartData.filter(
        (item) => item.name === category
      ).length;
    });

    // Find the max number of occurrences for any category to determine series count
    const maxSeriesNeeded = Math.max(...Object.values(maxOccurrences));

    // Create series array with proper structure for stacked bar
    const series = [];
    for (let i = 0; i < maxSeriesNeeded; i++) {
      // Create a series for each occurrence level
      series.push({
        name: `Occurrence ${i + 1}`,
        data: [], // This will be filled with values for each category
      });
    }

    // For each unique category, fill in the data for each series
    uniqueCategories.forEach((category) => {
      // Get all occurrences of this category
      const occurrences = chartData
        .filter((item) => item.name === category)
        .map((item) => parseInt(item.y) || 0);

      // Fill in the data for each series
      for (let i = 0; i < maxSeriesNeeded; i++) {
        if (i < occurrences.length) {
          // If we have data for this occurrence, use it
          series[i].data.push(occurrences[i]);
        } else {
          // Otherwise push 0 to maintain proper alignment
          series[i].data.push(0);
        }
      }
    });

    // Add colors to make it more visually appealing
    const colors = this.generateColors(maxSeriesNeeded);
    series.forEach((s, index) => {
      s.color = colors[index % colors.length];
    });

    return {
      categories: uniqueCategories,
      series: series,
    };
  };
  extractRawData = (chartData) => {
    if (Array.isArray(chartData)) {
      return chartData;
    }

    if (
      chartData &&
      chartData.chart_data &&
      Array.isArray(chartData.chart_data)
    ) {
      return chartData.chart_data;
    }

    if (
      chartData &&
      chartData.labels &&
      chartData.datasets &&
      chartData.datasets[0]
    ) {
      return chartData.labels.map((label, idx) => ({
        name: label,
        y: chartData.datasets[0].data[idx] || 0,
        target: chartData.datasets[0].targets
          ? chartData.datasets[0].targets[idx]
          : undefined,
      }));
    }

    return [];
  };
  createHighchartsOptions = (chartData, chartType) => {
    if (chartType === "CARD" || chartType === "BISCUIT") {
      return {}; // Return empty object, not null
    }

    // For new chart types that need raw data array
    if (
      [
        "GAUGE",
        "SOLIDGAUGE",
        "BARTARGET",
        "MULTIBARTARGET",
        "VARIABLERADIUSPIE",
      ].includes(chartType)
    ) {
      const rawData = this.extractRawData(chartData);

      if (!rawData || rawData.length === 0) {
        console.warn(`No data available for ${chartType}`);
        return null;
      }

      return this.createNewChartOptions(rawData, chartData, chartType);
    }
    if (
      !chartData ||
      !chartData.labels ||
      !chartData.datasets ||
      !chartData.datasets[0].data
    ) {
      return null;
    }
    const labels = chartData.labels;
    const data = chartData.datasets[0].data;
    const title = chartData.datasets[0].label || "Widget";
    const colors = this.generateColors(data.length);
    const drilldownSeries = chartData.drilldown
      ? chartData.drilldown.series
      : [];
    const widgetId = chartData.widgetId;
    const sourcereportId = chartData.sourcereportId;
    const destinationreportId = chartData.destinationreportId;
    const baseOptions = {
      chart: {
        type: this.mapChartType(chartType),
      },
      title: {
        text: title,
      },
      credits: {
        enabled: false,
      },
      exporting: {
        enabled: true,
        fallbackToExportServer: false,
        libURL: "https://code.highcharts.com/lib/",
        menuItemDefinitions: {
          viewFullscreen: {
            textKey: "viewFullscreen",
            onclick: function () {
              this.fullscreen.toggle();
            },
          },
        },
        buttons: {
          contextButton: {
            menuItems: [
              "viewFullscreen",
              "printChart",
              "separator",
              "downloadPNG",
              "downloadJPEG",
              "downloadPDF",
              "downloadSVG",
            ],
            align: "right",
            symbolSize: 14,
            symbolStrokeWidth: 1,
          },
        },
      },
      legend: {
        enabled: true,
      },
      tooltip: {
        pointFormat: "{series.name}: <b>{point.y}</b>",
      },
      plotOptions: {
        series: {
          point: {
            events: {
              click: (e) =>
                this.drillDownevent(
                  e,
                  widgetId,
                  destinationreportId,
                  sourcereportId
                ),
            },
          },
        },
      },
    };
    switch (chartType) {
      case "PIE":
        return {
          ...baseOptions,
          xAxis: {
            categories: labels,
            title: {
              text: null,
            },
          },
          yAxis: {
            title: {
              text: title,
            },
          },
          plotOptions: {
            pie: {
              allowPointSelect: true,
              cursor: "pointer",
              dataLabels: {
                enabled: true,
                format: "<b>{point.name}</b>: {point.y}",
              },
              point: {
                events: {
                  click: (e) =>
                    this.drillDownevent(
                      e,
                      widgetId,
                      destinationreportId,
                      sourcereportId
                    ),
                },
              },
            },
          },
          series: [
            {
              name: title,
              colorByPoint: true,
              data: labels.map((label, index) => ({
                name: label,
                y: data[index],
                //drilldown: label,
              })),
              color: colors[0],
            },
          ],
          tooltip: {
            pointFormat: "{series.name}: <b>{point.y}</b>",
          },
          drilldown: {
            series: drilldownSeries,
          },
        };
      case "LINE":
        return {
          ...baseOptions,
          xAxis: {
            categories: labels,
            title: {
              text: null,
            },
          },
          yAxis: {
            title: {
              text: title,
            },
          },
          plotOptions: {
            line: {
              dataLabels: {
                enabled: true,
              },
              cursor: "pointer",
              point: {
                events: {
                  click: (e) =>
                    this.drillDownevent(
                      e,
                      widgetId,
                      destinationreportId,
                      sourcereportId
                    ),
                },
              },
            },
          },
          series: [
            {
              name: title,
              colorByPoint: true,
              data: labels.map((label, index) => ({
                name: label,
                y: data[index],
              })),
              color: colors[0],
            },
          ],
          drilldown: {
            series: drilldownSeries,
          },
        };
      case "DONUT":
        return {
          ...baseOptions,
          xAxis: {
            categories: labels,
            title: {
              text: null,
            },
          },
          yAxis: {
            title: {
              text: title,
            },
          },
          plotOptions: {
            pie: {
              innerSize: "50%", // This makes it a donut
              allowPointSelect: true,
              cursor: "pointer",
              dataLabels: {
                enabled: true,
                format: "<b>{point.name}</b>: {point.y}",
              },
              point: {
                events: {
                  click: (e) =>
                    this.drillDownevent(
                      e,
                      widgetId,
                      destinationreportId,
                      sourcereportId
                    ),
                },
              },
            },
          },
          series: [
            {
              name: title,
              colorByPoint: true,
              data: labels.map((label, index) => ({
                name: label,
                y: data[index],
              })),
              color: colors[0],
            },
          ],
          drilldown: {
            series: drilldownSeries,
          },
        };
      case "BAR":
        return {
          ...baseOptions,
          xAxis: {
            categories: labels,
            title: {
              text: null,
            },
          },
          yAxis: {
            title: {
              text: title,
            },
          },
          plotOptions: {
            column: {
              cursor: "pointer",
              dataLabels: {
                enabled: true,
                format: "{point.y}",
              },
              point: {
                events: {
                  click: (e) =>
                    this.drillDownevent(
                      e,
                      widgetId,
                      destinationreportId,
                      sourcereportId
                    ),
                },
              },
            },
          },
          series: [
            {
              name: title,
              colorByPoint: true,
              data: labels.map((label, index) => ({
                name: label,
                y: data[index],
              })),
              color: colors[0],
            },
          ],
          drilldown: {
            series: drilldownSeries,
          },
        };
      case "FUNNEL":
        return {
          ...baseOptions,
          chart: { type: "funnel" },
          plotOptions: {
            series: {
              cursor: "pointer",
              dataLabels: {
                enabled: true,
                format: "<b>{point.name}</b>: {point.y}",
                softConnector: true,
              },
              center: ["50%", "50%"],
              neckWidth: "30%",
              neckHeight: "25%",
              width: "80%",
              point: {
                events: {
                  click: (e) =>
                    this.drillDownevent(
                      e,
                      widgetId,
                      destinationreportId,
                      sourcereportId
                    ),
                },
              },
            },
          },
          series: [
            {
              name: title,
              colorByPoint: true,
              data: labels.map((label, index) => ({
                name: label,
                y: data[index],
              })),
              color: colors[0],
            },
          ],
          drilldown: {
            series: drilldownSeries,
          },
        };
      case "STACKEDBAR":
        const processedData = this.prepareStackedOrGroupedData(
          chartData.chart_data
        );
        return {
          ...baseOptions,
          chart: { type: "column" },
          xAxis: {
            categories: processedData.categories,
            crosshair: true,
          },
          yAxis: {
            min: 0,
            title: { text: "Total" },
            stackLabels: {
              enabled: true,
              style: {
                fontWeight: "bold",
                color: "black",
              },
            },
          },
          tooltip: {
            headerFormat:
              '<span style="font-size:10px">{point.key}</span><table>',
            pointFormat:
              '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
              '<td style="padding:0"><b>{point.y}</b></td></tr>',
            footerFormat: "</table>",
            shared: true,
            useHTML: true,
          },
          plotOptions: {
            column: {
              stacking: "normal",
              dataLabels: {
                enabled: true,
                formatter: function () {
                  if (this.y !== 0) {
                    return this.y;
                  }
                  return null;
                },
              },
              point: {
                events: {
                  click: (e) =>
                    this.drillDownevent(
                      e,
                      widgetId,
                      destinationreportId,
                      sourcereportId
                    ),
                },
              },
            },
          },
          series: processedData.series,
        };
      default:
        return {
          ...baseOptions,
          xAxis: {
            categories: labels,
          },
          series: [
            {
              name: title,
              data: data,
            },
          ],
        };
    }
  };
  createNewChartOptions = (rawData, originalChartData, chartType) => {
    const widgetId = originalChartData.widgetId;
    const sourcereportId = originalChartData.sourcereportId;
    const destinationreportId = originalChartData.destinationreportId;

    const baseOptions = {
      chart: {
        type: this.mapChartType(chartType),
      },
      title: {
        text: originalChartData.datasets?.[0]?.label || "Data Visualization",
      },
      credits: {
        enabled: false,
      },
      exporting: {
        enabled: true,
      },
    };

    switch (chartType) {
      case "GAUGE":
        const gaugeValue = parseFloat(rawData[0]?.y || 0);
        const maxValue = 1000; // You can make this configurable

        return {
          ...baseOptions,
          chart: {
            type: "gauge",
            plotBackgroundColor: null,
            plotBackgroundImage: null,
            plotBorderWidth: 0,
            plotShadow: false,
            height: "80%",
          },
          pane: {
            startAngle: -90,
            endAngle: 89.9,
            background: null,
            center: ["50%", "75%"],
            size: "110%",
          },
          yAxis: {
            min: 0,
            max: maxValue,
            tickPixelInterval: 72,
            tickPosition: "inside",
            tickColor: "#FFFFFF",
            tickLength: 20,
            tickWidth: 2,
            minorTickInterval: null,
            labels: {
              distance: 20,
              style: {
                fontSize: "14px",
              },
            },
            lineWidth: 0,
            plotBands: [
              {
                from: 0,
                to: maxValue * 0.6,
                color: "#DF5353",
                thickness: 20,
              },
              {
                from: maxValue * 0.6,
                to: maxValue * 0.8,
                color: "#DDDF0D",
                thickness: 20,
              },
              {
                from: maxValue * 0.8,
                to: maxValue,
                color: "#55BF3B",
                thickness: 20,
              },
            ],
          },
          series: [
            {
              name: "Value",
              data: [gaugeValue],
              tooltip: {
                valueSuffix: "",
              },
              dataLabels: {
                format: "{y}",
                borderWidth: 0,
                color: "#333333",
                style: {
                  fontSize: "16px",
                },
              },
              dial: {
                radius: "80%",
                backgroundColor: "gray",
                baseWidth: 12,
                baseLength: "0%",
                rearLength: "0%",
              },
              pivot: {
                backgroundColor: "gray",
                radius: 6,
              },
            },
          ],
        };

      case "SOLIDGAUGE":
        const solidGaugeValue = parseFloat(rawData[0]?.y || 0);
        const solidMaxValue = 400;

        return {
          ...baseOptions,
          chart: {
            type: "solidgauge",
            height: "80%",
          },
          pane: {
            center: ["50%", "85%"],
            size: "140%",
            startAngle: -90,
            endAngle: 90,
            background: {
              backgroundColor: "#EEE",
              innerRadius: "60%",
              outerRadius: "100%",
              shape: "arc",
            },
          },
          tooltip: {
            enabled: false,
          },
          yAxis: {
            min: 0,
            max: solidMaxValue,
            stops: [
              [0.1, "#DF5353"],
              [0.5, "#DDDF0D"],
              [0.9, "#55BF3B"],
            ],
            lineWidth: 0,
            tickWidth: 0,
            minorTickInterval: null,
            tickAmount: 2,
            title: {
              y: -70,
            },
            labels: {
              y: 16,
            },
          },
          plotOptions: {
            solidgauge: {
              dataLabels: {
                y: 5,
                borderWidth: 0,
                useHTML: true,
              },
            },
          },
          series: [
            {
              name: "Value",
              data: [solidGaugeValue],
              dataLabels: {
                format:
                  '<div style="text-align:center">' +
                  '<span style="font-size:25px">{y}</span><br/>' +
                  '<span style="font-size:12px;opacity:0.4">of ' +
                  solidMaxValue +
                  "</span>" +
                  "</div>",
              },
            },
          ],
        };

      case "BARTARGET":
        const barValue = parseFloat(rawData[0]?.y || 0);
        const targetValue = 800;

        return {
          ...baseOptions,
          chart: {
            type: "bar",
            height: 150,
          },
          xAxis: {
            categories: ["Progress"],
            title: {
              text: null,
            },
          },
          yAxis: {
            min: 0,
            max: targetValue * 1.2,
            title: {
              text: "Value",
              align: "high",
            },
            labels: {
              overflow: "justify",
            },
            plotLines: [
              {
                color: "#000",
                width: 2,
                value: targetValue,
                zIndex: 4,
                label: {
                  text: "Target: " + targetValue,
                  align: "right",
                  style: {
                    color: "#000",
                    fontWeight: "bold",
                  },
                },
              },
            ],
          },
          tooltip: {
            valueSuffix: "",
          },
          plotOptions: {
            bar: {
              dataLabels: {
                enabled: true,
                format: "{y}",
              },
            },
          },
          legend: {
            enabled: true,
          },
          series: [
            {
              name: "Achieved",
              data: [barValue],
              color: "#90ed7d",
            },
          ],
        };

      case "MULTIBARTARGET":
        const categories = rawData.map((item) => item.name);
        const achieved = rawData.map((item) => parseFloat(item.y || 0));
        const targets = rawData.map((item) =>
          parseFloat(item.target || item.z || 0)
        );

        return {
          ...baseOptions,
          chart: {
            type: "bar",
          },
          xAxis: {
            categories: categories,
            title: {
              text: null,
            },
          },
          yAxis: {
            min: 0,
            title: {
              text: "Values",
              align: "high",
            },
            labels: {
              overflow: "justify",
            },
          },
          tooltip: {
            shared: true,
          },
          plotOptions: {
            bar: {
              dataLabels: {
                enabled: true,
              },
            },
            series: {
              pointWidth: 20,
            },
          },
          series: [
            {
              name: "Achieved",
              data: achieved,
              color: "#90ed7d",
            },
            {
              name: "Target",
              data: targets,
              color: "#434348",
              type: "scatter",
              marker: {
                symbol: "line",
                lineWidth: 2,
                radius: 8,
                lineColor: "#000",
              },
              dataLabels: {
                enabled: true,
                format: "Target: {y}",
              },
            },
          ],
        };

      case "VARIABLERADIUSPIE":
        return {
          ...baseOptions,
          chart: { type: "variablepie" },
          tooltip: {
            pointFormat:
              "<b>{point.name}</b><br/>Y: {point.y}<br/>Z: {point.z}",
          },
          series: [
            {
              minPointSize: 10,
              innerSize: "20%",
              zMin: 0,
              name: "Data",
              data: rawData,
            },
          ],
          plotOptions: {
            series: {
              point: {
                events: {
                  click: (e) =>
                    this.drillDownevent(
                      e,
                      widgetId,
                      destinationreportId,
                      sourcereportId
                    ),
                },
              },
            },
          },
        };

      default:
        return baseOptions;
    }
  };
  mapChartType = (chartType) => {
    switch (chartType) {
      case "BAR":
        return "column";
      case "LINE":
        return "line";
      case "PIE":
      case "DONUT":
        return "pie";
      case "STACKEDBAR":
      case "GROUPEDBAR":
        return "column";
      case "FUNNEL":
        return "funnel";
      case "VARIABLERADIUSPIE":
        return "variablepie";
      default:
        return "column";
    }
  };

  generateColors = (numColors) => {
    const colors = [
      "#FF6384",
      "#36A2EB",
      "#FFCE56",
      "#4BC0C0",
      "#9966FF",
      "#FF9F40",
      "#FFCD56",
      "#FF67A7",
      "#58D68D",
      "#48C9B0",
    ];
    return Array.from(
      { length: numColors },
      (_, index) => colors[index % colors.length]
    );
  };

  renderChartPreview = () => {
    const { chartData, widgetId, chartType, widgetName, aggregation } =
      this.state;
    const hasDrilldown =
      (this.state.drillStackByWidget[widgetId] || []).length > 0;

    if (!chartData) {
      return (
        <p>
          No data available for preview. Please configure and click Preview.
        </p>
      );
    }

    const rawChartData = this.extractRawData(chartData);

    // Handle CARD type
    if (chartType === "CARD") {
      if (!rawChartData || rawChartData.length === 0) {
        return <div className="text-center p-4">No data available</div>;
      }

      const mainValue = rawChartData.reduce(
        (sum, item) => sum + (item.y || 0),
        0
      );
      const comparisonValue = rawChartData[0]?.comparison || 0;
      const isIncrease =
        comparisonValue > 0 ? mainValue >= comparisonValue : true;

      return (
        <Card
          style={{
            textAlign: "center",
            padding: "20px",
            minHeight: "150px",
            border: "1px solid #e0e0e0",
            borderRadius: "8px",
          }}
        >
          <Card.Body>
            <h6
              style={{
                fontSize: "14px",
                fontWeight: "600",
                color: "#666",
                marginBottom: "15px",
              }}
            >
              {widgetName || "Metric"}
            </h6>

            <h2
              style={{
                fontSize: "36px",
                fontWeight: "700",
                color: "#333",
                marginBottom: "10px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "10px",
              }}
            >
              {this.formatCardValue(mainValue, aggregation)}
              {comparisonValue !== 0 && (
                <span
                  style={{
                    fontSize: "24px",
                    color: isIncrease ? "#4CAF50" : "#f44336",
                  }}
                >
                  {isIncrease ? "↑" : "↓"}
                </span>
              )}
            </h2>

            {comparisonValue !== 0 && (
              <p
                style={{
                  fontSize: "12px",
                  color: "#999",
                  marginTop: "10px",
                }}
              >
                Previous: {this.formatCardValue(comparisonValue, aggregation)}
              </p>
            )}

            {rawChartData.length > 1 && (
              <div
                style={{ marginTop: "15px", fontSize: "11px", color: "#999" }}
              >
                <details>
                  <summary style={{ cursor: "pointer" }}>
                    View Breakdown
                  </summary>
                  <div style={{ marginTop: "10px" }}>
                    {rawChartData.map((item, idx) => (
                      <div key={idx} style={{ padding: "4px 0" }}>
                        {item.name}: {this.formatCardValue(item.y, aggregation)}
                      </div>
                    ))}
                  </div>
                </details>
              </div>
            )}
          </Card.Body>
        </Card>
      );
    }

    // Handle BISCUIT type
    if (chartType === "BISCUIT") {
      if (!rawChartData || rawChartData.length === 0) {
        return <div className="text-center p-4">No data available</div>;
      }

      const grandTotal = rawChartData.reduce(
        (sum, item) => sum + (item.y || 0),
        0
      );

      return (
        <Card style={{ padding: "15px" }}>
          <h5 style={{ fontWeight: "600", marginBottom: "15px" }}>
            {widgetName || "Top Items"}
          </h5>

          {rawChartData.map((item, idx) => {
            const aggregatedValue = item.y || 0;
            const groupName = item.name || "N/A";
            const percentage =
              grandTotal > 0
                ? ((aggregatedValue / grandTotal) * 100).toFixed(1)
                : 0;

            return (
              <div
                key={idx}
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  marginBottom: "12px",
                }}
              >
                <span style={{ fontWeight: "600" }}>{groupName}</span>

                <span
                  style={{
                    fontWeight: "500",
                    textAlign: "right",
                    minWidth: "100px",
                  }}
                >
                  {this.formatIndianCurrency(aggregatedValue)}
                </span>

                <span
                  style={{
                    background: "#4CAF50",
                    color: "white",
                    padding: "4px 10px",
                    borderRadius: "20px",
                    fontSize: "12px",
                    marginLeft: "10px",
                  }}
                >
                  {percentage}%
                </span>
              </div>
            );
          })}
        </Card>
      );
    }

    // Handle all Highcharts types
    const highchartsOptions = this.createHighchartsOptions(
      chartData,
      chartType || "PIE"
    );

    if (!highchartsOptions || Object.keys(highchartsOptions).length === 0) {
      return (
        <div className="text-center p-4">Unable to generate chart options</div>
      );
    }

    return (
      <div>
        {hasDrilldown && (
          <button
            className="btn btn-secondary btn-sm mb-2"
            onClick={() => this.handleDrillUp(widgetId)}
          >
            ← Back
          </button>
        )}
        <HighchartsReact
          highcharts={Highcharts}
          options={highchartsOptions}
          containerProps={{ style: { width: "100%", height: "400px" } }}
        />
      </div>
    );
  };
  formatIndianCurrency(value) {
    if (!value) return "₹0";
    return value.toLocaleString("en-IN", {
      style: "currency",
      currency: "INR",
      minimumFractionDigits: 2,
    });
  }

  formatCardValue = (value, aggregationType) => {
    if (aggregationType === "count") {
      return Math.round(value).toLocaleString();
    } else if (aggregationType === "sum" || aggregationType === "average") {
      if (value >= 1000000) {
        return `₹${(value / 1000000).toFixed(2)}M`;
      } else if (value >= 1000) {
        return `₹${(value / 1000).toFixed(2)}K`;
      } else {
        return `₹${value.toFixed(2)}`;
      }
    }
    return value.toLocaleString();
  };

  // Add method to render individual widget based on type
  // renderWidgetContent = (widget, widgetChartData) => {
  //   const chartType = widget.widgetDetails.chartType;
  //   const chartData = this.extractRawData(widgetChartData);

  //   // Handle CARD type
  //   if (chartType === "CARD") {
  //     if (!chartData || chartData.length === 0) {
  //       return <div className="text-center p-4">No data available</div>;
  //     }

  //     const mainValue = chartData.reduce((sum, item) => sum + (item.y || 0), 0);
  //     const comparisonValue = chartData[0]?.comparison || 0;
  //     const isIncrease =
  //       comparisonValue > 0 ? mainValue >= comparisonValue : true;
  //     const aggregationType = widget.widgetDetails.aggregation || "sum";

  //     return (
  //       <div
  //         style={{
  //           textAlign: "center",
  //           padding: "20px",
  //           minHeight: "150px",
  //         }}
  //       >
  //         <h6
  //           style={{
  //             fontSize: "14px",
  //             fontWeight: "600",
  //             color: "#666",
  //             marginBottom: "15px",
  //           }}
  //         >
  //           {widget.widgetDetails.widgetName || "Metric"}
  //         </h6>

  //         <h2
  //           style={{
  //             fontSize: "36px",
  //             fontWeight: "700",
  //             color: "#333",
  //             marginBottom: "10px",
  //             display: "flex",
  //             alignItems: "center",
  //             justifyContent: "center",
  //             gap: "10px",
  //           }}
  //         >
  //           {this.formatCardValue(mainValue, aggregationType)}
  //           {comparisonValue !== 0 && (
  //             <span
  //               style={{
  //                 fontSize: "24px",
  //                 color: isIncrease ? "#4CAF50" : "#f44336",
  //               }}
  //             >
  //               {isIncrease ? "↑" : "↓"}
  //             </span>
  //           )}
  //         </h2>

  //         {comparisonValue !== 0 && (
  //           <p
  //             style={{
  //               fontSize: "12px",
  //               color: "#999",
  //               marginTop: "10px",
  //             }}
  //           >
  //             Previous: {this.formatCardValue(comparisonValue, aggregationType)}
  //           </p>
  //         )}

  //         {chartData.length > 1 && (
  //           <div style={{ marginTop: "15px", fontSize: "11px", color: "#999" }}>
  //             <details>
  //               <summary style={{ cursor: "pointer" }}>View Breakdown</summary>
  //               <div style={{ marginTop: "10px" }}>
  //                 {chartData.map((item, idx) => (
  //                   <div key={idx} style={{ padding: "4px 0" }}>
  //                     {item.name}:{" "}
  //                     {this.formatCardValue(item.y, aggregationType)}
  //                   </div>
  //                 ))}
  //               </div>
  //             </details>
  //           </div>
  //         )}
  //       </div>
  //     );
  //   }

  //   // Handle BISCUIT type
  //   if (chartType === "BISCUIT") {
  //     if (!chartData || chartData.length === 0) {
  //       return <div className="text-center p-4">No data available</div>;
  //     }

  //     const grandTotal = chartData.reduce(
  //       (sum, item) => sum + (item.y || 0),
  //       0
  //     );

  //     return (
  //       <div style={{ padding: "15px" }}>
  //         <h6 style={{ fontWeight: "600", marginBottom: "15px" }}>
  //           {widget.widgetDetails.widgetName}
  //         </h6>

  //         {chartData.map((item, idx) => {
  //           const aggregatedValue = item.y || 0;
  //           const groupName = item.name || "N/A";
  //           const percentage =
  //             grandTotal > 0
  //               ? ((aggregatedValue / grandTotal) * 100).toFixed(1)
  //               : 0;

  //           return (
  //             <div
  //               key={idx}
  //               style={{
  //                 display: "flex",
  //                 justifyContent: "space-between",
  //                 alignItems: "center",
  //                 marginBottom: "12px",
  //               }}
  //             >
  //               <span style={{ fontWeight: "600" }}>{groupName}</span>

  //               <span
  //                 style={{
  //                   fontWeight: "500",
  //                   textAlign: "right",
  //                   minWidth: "100px",
  //                 }}
  //               >
  //                 {this.formatIndianCurrency(aggregatedValue)}
  //               </span>

  //               <span
  //                 style={{
  //                   background: "#4CAF50",
  //                   color: "white",
  //                   padding: "4px 10px",
  //                   borderRadius: "20px",
  //                   fontSize: "12px",
  //                   marginLeft: "10px",
  //                 }}
  //               >
  //                 {percentage}%
  //               </span>
  //             </div>
  //           );
  //         })}
  //       </div>
  //     );
  //   }

  //   // Handle all Highcharts-based types
  //   const highchartsTypes = [
  //     "PIE",
  //     "BAR",
  //     "LINE",
  //     "DONUT",
  //     "FUNNEL",
  //     "STACKEDBAR",
  //     "GAUGE",
  //     "SOLIDGAUGE",
  //     "BARTARGET",
  //     "MULTIBARTARGET",
  //     "VARIABLERADIUSPIE",
  //   ];

  //   if (highchartsTypes.includes(chartType)) {
  //     const options = this.createHighchartsOptions(widgetChartData, chartType);

  //     if (!options || Object.keys(options).length === 0) {
  //       return (
  //         <div className="text-center p-4">
  //           No chart configuration available
  //         </div>
  //       );
  //     }

  //     return (
  //       <HighchartsReact
  //         highcharts={Highcharts}
  //         options={options}
  //         containerProps={{ style: { width: "100%", height: "400px" } }}
  //       />
  //     );
  //   }

  //   // Fallback for unknown chart types
  //   return (
  //     <div className="text-center p-4 text-muted">
  //       Chart type "{chartType}" is not supported
  //     </div>
  //   );
  // };
  renderWidgetContent = (widget, widgetChartData) => {
    if (!widgetChartData || !widgetChartData.labels) {
      return <div>Loading...</div>;
    }

    const chartType = this.mapChartType(widget.widgetDetails.chartType);
    // Use original widget ID from widget.widgetDetails for the card reference
    const originalWidgetId = widget.widgetDetails.widgetId;
    // Get current drilldown destination from chartData (updates after each drill)
    const currentDestinationId = widgetChartData.destinationreportId;

    // Create click handler that reads current values from state at CLICK TIME
    const handlePointClick = (e) => {
      // Get the LATEST chartData from state at click time (not render time)
      const latestChartData = this.state.chartData[`card_${originalWidgetId}`];
      const latestDestinationId = latestChartData?.destinationreportId;
      const latestSourceId = latestChartData?.sourcereportId;

      console.log("=== PIE CLICK DEBUG ===");
      console.log("Point clicked:", e.point.name);
      console.log("Original widgetId:", originalWidgetId);
      console.log("Latest destinationreportId:", latestDestinationId);
      console.log("Latest sourcereportId:", latestSourceId);
      console.log("Check conditions:");
      console.log("  - latestDestinationId exists:", !!latestDestinationId);
      console.log("  - latestDestinationId !== '0':", latestDestinationId !== "0");
      console.log("  - latestDestinationId !== null:", latestDestinationId !== null);
      console.log("  - Type of latestDestinationId:", typeof latestDestinationId);

      // Check if drilldown is available - handle both string "0" and number 0
      const canDrillDown = latestDestinationId &&
                           latestDestinationId !== "0" &&
                           latestDestinationId !== 0 &&
                           latestDestinationId !== null &&
                           latestDestinationId !== undefined &&
                           latestDestinationId !== "";

      console.log("Can drill down:", canDrillDown);

      if (canDrillDown) {
        this.drillDownevent(
          e,
          originalWidgetId,
          latestDestinationId,
          latestSourceId
        );
      } else {
        console.log("No further drilldown available - destinationreportId is:", latestDestinationId);
      }
    };

    const chartOptions = {
      chart: {
        type: chartType,
        height: 300,
      },
      title: {
        text: null,
      },
      xAxis: {
        categories: widgetChartData.labels,
        title: {
          text: null,
        },
      },
      yAxis: {
        title: {
          text: "Count",
        },
      },
      legend: {
        enabled: chartType === "pie",
      },
      credits: {
        enabled: false,
      },
      exporting: {
        enabled: true,
        buttons: {
          contextButton: {
            menuItems: [
              "downloadPNG",
              "downloadJPEG",
              "downloadPDF",
              "downloadSVG",
            ],
          },
        },
      },
      plotOptions: {
        series: {
          // Always show pointer cursor - handler will check if drilldown is available
          cursor: "pointer",
          point: {
            events: {
              // Always attach click handler - it checks drilldown availability at click time
              click: handlePointClick,
            },
          },
        },
        pie: {
          allowPointSelect: true,
          cursor: "pointer",
          dataLabels: {
            enabled: true,
            format: "<b>{point.name}</b>: {point.y}",
          },
          point: {
            events: {
              click: handlePointClick,
            },
          },
        },
      },
      series: [
        {
          name: widgetChartData.datasets[0].label,
          data: widgetChartData.labels.map((label, index) => ({
            name: label,
            y: widgetChartData.datasets[0].data[index],
            color: widgetChartData.datasets[0].backgroundColor[index],
          })),
        },
      ],
    };

    // Force re-render when destination changes by using unique key
    const chartKey = `${originalWidgetId}-${currentDestinationId || 'root'}-${Date.now()}`;

    return (
      <HighchartsReact
        highcharts={Highcharts}
        options={chartOptions}
        key={chartKey}
      />
    );
  };
  endCurrentSession() {
    const logoutTime = new Date().toLocaleTimeString("en-US", {
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
    });
    this.setState((prevState) => ({
      logoutTimes: [...prevState.logoutTimes, logoutTime],
    }));
  }

  tick() {
    this.setState({
      time: new Date(),
    });
  }

  getGreeting() {
    const hour = this.state.time.getHours();
    if (hour < 12) return "Good morning";
    if (hour < 18) return "Good afternoon";
    return "Good evening";
  }

  render() {
    //const ResponsiveGridLayout = WidthProvider(Responsive);
    const greeting = this.getGreeting();
    const uName = sessionStorage.getItem("userName");
    const currentTime = this.state.time.toLocaleTimeString("en-US", {
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
    });

    return (
      <div className="">
        <LoadingOverlay show={this.state.loading} message={this.state.loadingMessage} />
        <Row>
          <div className="col-lg-12">
            <div className="p-3 card">
              <div className="row justify-content-between">
                <div className="col-lg-3">
                  <Dropdown className="d-inline mx-2 overview">
                    <Dropdown.Toggle
                      id="dropdown-autoclose-true"
                      className="btn btn-light"
                      style={{ marginTop: "5px", border: "1px solid #23ae73" }}
                    >
                      Overview
                    </Dropdown.Toggle>
                    <Dropdown.Menu></Dropdown.Menu>
                  </Dropdown>
                  <span className="bi bi-lock"></span>
                </div>

                <div className="col-lg-3">
                  <span className="bi bi-arrow-clockwise"></span>
                  <Dropdown className="d-inline mx-2 component">
                    <Dropdown.Toggle
                      id="dropdown-autoclose-true"
                      className="btn btn-light"
                      style={{ marginTop: "5px", border: "1px solid #23ae73" }}
                    >
                      + Component
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                      <Dropdown.Item>
                        <Link to="">KPI</Link>
                      </Dropdown.Item>
                      <Dropdown.Item>
                        <Link onClick={this.handleShowOne}>Chart Creation</Link>
                      </Dropdown.Item>
                      <Dropdown.Item>
                        <Link to="Dashboardcharts">Employee Chart</Link>
                      </Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                  <Dropdown className="d-inline mx-2 component">
                    <Dropdown.Toggle
                      id="dropdown-autoclose-true"
                      className="btn btn-light"
                      style={{ marginTop: "5px", border: "1px solid #23ae73" }}
                    ></Dropdown.Toggle>
                    <Dropdown.Menu>
                      <Dropdown.Item>
                        <Link to="">View in Full Screen</Link>
                      </Dropdown.Item>
                      <Dropdown.Item>
                        <Link to="">Delete</Link>
                      </Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                </div>
              </div>
            </div>
          </div>
        </Row>
        <br />
        <Row className="mb-4">
          <Col md={12} lg="12">
            <Card className="p-3">
              <Row>
                <Col lg="9" md="9">
                  <h2>
                    {greeting}, {uName}!
                  </h2>
                  <p>Your performance is looking good!</p>
                </Col>
                <Col>
                  <p>Current time: {currentTime}</p>
                </Col>
              </Row>
            </Card>
          </Col>
        </Row>
        <Row className="mb-4">
          {this.state.layout.map((widget, index) => {
            const widgetChartData = this.state.chartData[widget.i];
            const totalCount = widgetChartData?.totalCount;
            const widgetId = widgetChartData?.widgetId;
            const hasDrilldown =
              widgetId &&
              this.state.drillStackByWidget[widgetId] &&
              this.state.drillStackByWidget[widgetId].length > 0;
            const chartType = widget.widgetDetails.chartType;
            const widgetName = widget.widgetDetails.widgetName;
            return (
              <Col
                xs={12}
                sm={6}
                md={6}
                lg={4}
                key={index + 1}
                // style={
                //   {
                //     width: widget.w,
                //     height: widget.h,
                //     minWidth: widget.minW,
                //     minHeight: widget.minH,
                //     position: "relative",
                //     margin: "0 auto",
                //   }
                // }
              >
                <Card className="mt-3 mb-2" key={widget.i}>
                  <div
                    style={{
                      padding: "10px",
                      background: "#f8f9fa",
                      borderRadius: "4px",
                    }}
                  >
                    <div className="d-flex justify-content-between align-items-center mb-2">
                      <h5 className="mb-0">
                        {widget.widgetDetails.widgetName}
                      </h5>
                      {totalCount !== undefined && (
                        <h6 className="mb-0 text-muted">Total: {totalCount}</h6>
                      )}
                    </div>
                    {hasDrilldown && (
                      <button
                        className="btn btn-sm btn-secondary"
                        onClick={() => this.handleDrillUp(widgetId)}
                      >
                        ← Back
                      </button>
                    )}
                    <div>
                      {/* {widget.widgetDetails.chartType === "PIE" && (
                              <HighchartsReact
                                highcharts={Highcharts}
                                options={this.createHighchartsOptions(
                                  widgetChartData,
                                  "PIE"
                                )}
                                containerProps={{
                                  style: { width: "100%", height: "400px" },
                                }}
                              />
                            )}
                            {widget.widgetDetails.chartType === "BAR" && (
                              <HighchartsReact
                                highcharts={Highcharts}
                                options={this.createHighchartsOptions(
                                  widgetChartData,
                                  "BAR"
                                )}
                                containerProps={{
                                  style: { width: "100%", height: "400px" },
                                }}
                              />
                            )}
                            {widget.widgetDetails.chartType === "LINE" && (
                              <HighchartsReact
                                highcharts={Highcharts}
                                options={this.createHighchartsOptions(
                                  widgetChartData,
                                  "LINE"
                                )}
                                containerProps={{
                                  style: { width: "100%", height: "400px" },
                                }}
                              />
                            )}
                            {widget.widgetDetails.chartType === "DONUT" && (
                              <HighchartsReact
                                highcharts={Highcharts}
                                options={this.createHighchartsOptions(
                                  widgetChartData,
                                  "DONUT"
                                )}
                                containerProps={{
                                  style: { width: "100%", height: "400px" },
                                }}
                              />
                            )}
                            {widget.widgetDetails.chartType === "FUNNEL" && (
                              <HighchartsReact
                                highcharts={Highcharts}
                                options={this.createHighchartsOptions(
                                  widgetChartData,
                                  "FUNNEL"
                                )}
                                containerProps={{
                                  style: { width: "100%", height: "400px" },
                                }}
                              />
                            )}
                            {widget.widgetDetails.chartType === "STACKEDBAR" &&
                              widgetChartData &&
                              widgetChartData.chart_data && (
                                <HighchartsReact
                                  highcharts={Highcharts}
                                  options={this.createHighchartsOptions(
                                    widgetChartData,
                                    "STACKEDBAR"
                                  )}
                                  containerProps={{
                                    style: { width: "100%", height: "400px" },
                                  }}
                                />
                              )}
                              {widget.widgetDetails.chartType === "CARD" &&
                              widgetChartData &&
                              widgetChartData.chart_data && (
                                <HighchartsReact
                                  highcharts={Highcharts}
                                  options={this.createHighchartsOptions(
                                    widgetChartData,
                                    "CARD"
                                  )}
                                  containerProps={{
                                    style: { width: "100%", height: "400px" },
                                  }}
                                />
                              )}
                              {widget.widgetDetails.chartType === "BISCUIT" &&
                              widgetChartData &&
                              widgetChartData.chart_data && (
                                <HighchartsReact
                                  highcharts={Highcharts}
                                  options={this.createHighchartsOptions(
                                    widgetChartData,
                                    "BISCUIT"
                                  )}
                                  containerProps={{
                                    style: { width: "100%", height: "400px" },
                                  }}
                                />
                              )} */}
                      {this.renderWidgetContent(widget, widgetChartData)}
                      {/* Handle other chart types */}
                      {/* {widget.widgetDetails.chartType !== "STACKEDBAR" &&
                              widgetChartData && (
                                <HighchartsReact
                                  highcharts={Highcharts}
                                  options={this.createHighchartsOptions(
                                    widgetChartData,
                                    widget.widgetDetails.chartType
                                  )}
                                  containerProps={{
                                    style: { width: "100%", height: "400px" },
                                  }}
                                />
                              )} */}
                    </div>
                  </div>
                </Card>
              </Col>
            );
          })}
        </Row>
        <div>
          <Modal
            size="lg"
            show={this.state.showOne}
            onHide={this.handleCloseOne}
          >
            <Modal.Header closeButton>
              <Modal.Title>Regularize note</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Form>
                <Form.Group controlId="chartType">
                  <Form.Label>Select Chart Type</Form.Label>
                  <Form.Control
                    as="select"
                    value={this.state.dashboard}
                    name="dashboard"
                    onChange={this.handleChartTypeChange}
                  >
                    <option value="">Select Widget</option>

                    {this.state.data.map((api, index, idx) => (
                      <option key={index} value={api.widgetId}>
                        {api.widgetName}
                      </option>
                    ))}
                  </Form.Control>
                </Form.Group>
                <br />
                <Button
                  variant="primary"
                  style={{ float: "right", marginTop: "5px" }}
                  //onClick={this.handleNextWidStep}
                >
                  Save
                </Button>
              </Form>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={this.handleCloseOne}>
                Close
              </Button>
              <Button variant="primary" onClick={this.handleSubmit}>
                Submit
              </Button>
            </Modal.Footer>
          </Modal>
        </div>
        <Row>
          <Outlet />
        </Row>
      </div>
    );
  }
}
